import {observer} from "mobx-react";
import React from "react"
import styles from "./style.module.sass"
import {FlexRowSpaceBetween} from "../../../../../components/containers/containers";
import PriceComponent from "../../../../../components/priceComponent";
import {PlusGreyButton} from "../../../../../components/buttons/plusButton";
import {useStores} from "../../../../../hooks";
import useOpenMenuItem from "../../../../../hooks/useOpenMenuItem";
import {MenuItem} from "../../../../../services/menu/models";
import {useTranslation} from "react-i18next";
import PlusMinusWidget from "../../../../../components/plusMinusWidget";
import ItemBadges from "../../../../../components/itemBadges";
import {resolveItemBadges} from "../../../../../components/itemBadges/libs";

interface IProps {
    item: MenuItem,
}


const MenuItemNoPhotoComponent = ({ item }: IProps) => {

    const { cartStore, menuStore } = useStores();
    const isInCart = cartStore.isInCart(item.id);
    const { i18n } = useTranslation();
    const locale = i18n.language;
    const { openMenuItem } = useOpenMenuItem();


    const badges = resolveItemBadges(item, menuStore.badgesById);

    const onPlusClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (item.data.menuItemModifierSets.length === 0) {
            cartStore.addItem(item, [], 1);
        } else {
            openMenuItem(item);
        }
    }

    const showModalWindow = () => {
        openMenuItem(item);
    };

    let price: number;
    if (item.data.sellPrice.price === 0) {
        price = menuStore.getMinPrice(item);
    } else {
        price = item.data.sellPrice.price;
    }

    return <div className={styles.menuItemContainer} onClick={showModalWindow}>
        <div className={styles.content}>
            <ItemBadges badges={badges.all}/>
            <p className={styles.title}>{item.data.name[locale]}</p>
            {(item.data.description[locale] || "").length > 0 && <p className={styles.description}>
                {item.data.description[locale]}
            </p>
            }
        </div>
        <div style={{
            padding: "0 5px",
            marginTop: 5,
            minWidth: "100%",
            boxSizing: "border-box"
        }}>
            {
                !isInCart ? <FlexRowSpaceBetween>
                        <PriceComponent
                            item={{
                                price: price,
                                currencyId: item.data.sellPrice.currencyId
                            }}
                        />
                        <PlusGreyButton onClick={onPlusClick}/>
                    </FlexRowSpaceBetween>
                    :
                    <FlexRowSpaceBetween>
                        <PriceComponent item={{
                            price: price,
                            currencyId: item.data.sellPrice.currencyId
                        }}/>
                        <PlusMinusWidget menuItem={item} index={0} onCartPage={false}/>
                    </FlexRowSpaceBetween>
            }

        </div>
    </div>
};

export default observer(MenuItemNoPhotoComponent);
